import {ADD_APPLIANCE, DELETE_APPLIANCE, EDIT_APPLIANCE, UPDATE_APPLIANCE, CLEAR} from '../actionTypes';

const initialState = {
    appliances: [{
        name: "Ceiling fan",
        wattage: 35,
        rate: 0.12,
        hours: 4,
        days: 200,
        kwh: 28,
        cost: 3.36
    }, {
        name: "Clothes dryer",
        wattage: 2790,
        rate: 0.12,
        hours: 1,
        days: 52,
        kwh: 145.08,
        cost: 17.41
    }, {
        name: "Clothes washer",
        wattage: 255,
        rate: 0.12,
        hours: 1,
        days: 52,
        kwh: 13.26,
        cost: 1.59
    }, {
        name: "Desktop Computer",
        wattage: 75,
        rate: 0.12,
        hours: 8,
        days: 200,
        kwh: 120,
        cost: 14.40
    }, {
        name: "Computer monitor",
        wattage: 42,
        rate: 0.12,
        hours: 8,
        days: 200,
        kwh: 67.2,
        cost: 8.06
    }, {
        name: "Dish washer",
        wattage: 330,
        rate: 0.12,
        hours: 1,
        days: 200,
        kwh: 66,
        cost: 7.92
    }, {
        name: "Garage Door opener",
        wattage: 400,
        rate: 0.12,
        hours: 0.5,
        days: 200,
        kwh: 40,
        cost: 4.80
    }, {
        name: "Microwave",
        wattage: 1500,
        rate: 0.12,
        hours: 0.5,
        days: 200,
        kwh: 150,
        cost: 18.00
    }, {
        name: "Printer",
        wattage: 13,
        rate: 0.12,
        hours: 0.5,
        days: 50,
        kwh: 0.325,
        cost: 0.04
    }, {
        name: "Refrigerator",
        wattage: 225,
        rate: 0.12,
        hours: 10,
        days: 365,
        kwh: 246.38,
        cost: 29.57
    }, {
        name: "Router/Modem",
        wattage: 6,
        rate: 0.12,
        hours: 24,
        days: 365,
        kwh: 52.56,
        cost: 6.31
    }, {
        name: "Stereo System",
        wattage: 33,
        rate: 0.12,
        hours: 1,
        days: 30,
        kwh: 0.99,
        cost: 0.12
    }, {
        name: "Television LCD",
        wattage: 150,
        rate: 0.12,
        hours: 1,
        days: 200,
        kwh: 30,
        cost: 3.60
    }, {
        name: "Toaster",
        wattage: 1100,
        rate: 0.12,
        hours: 0.2,
        days: 50,
        kwh: 11,
        cost: 1.32
    }, {
        name: "Vaccum",
        wattage: 542,
        rate: 0.12,
        hours: 1,
        days: 40,
        kwh: 21.68,
        cost: 2.60
    }, {
        name: "Light Bulb",
        wattage: 12,
        rate: 0.12,
        hours: 5,
        days: 365,
        kwh: 21.9,
        cost: 2.63
    }, {
        name: "Air conditioner",
        wattage: 3500,
        rate: 0.12,
        hours: 2,
        days: 50,
        kwh: 350,
        cost: 42
    }]
};

export default function(state = initialState, action) {
    switch (action.type) {
        case ADD_APPLIANCE: {
            const { appliance } = action.payload;

            return {
                appliances: [
                    ...state.appliances,
                    appliance
                ]
            };
        }
        case DELETE_APPLIANCE: {
            const { applianceId } = action.payload;
            let appliances = [...state.appliances];
            appliances.splice(applianceId, 1);
            return {
                appliances
            };
        }
        case EDIT_APPLIANCE: {
            const { applianceId } = action.payload;
            let editAppliance = state.appliances[applianceId];
            return {
                appliances: [
                    ...state.appliances,
                ],
                editAppliance,
                editApplianceId: applianceId
            };
        }
        case CLEAR: {
            return {
                appliances: [
                    ...state.appliances,
                ]
            };
        }
        case UPDATE_APPLIANCE: {
            const { applianceId, appliance } = action.payload;
            console.log(applianceId);
            console.log(appliance);
            let appliances = [...state.appliances];
            appliances.splice(applianceId, 1, appliance);

            return {appliances};
        }
        default:
            return state;
    }
}